/* eslint-disable max-len */
/**
 * @file 个人中心路由
 * @author gaoxunchen
 */

import _ from 'lodash';
import React from 'react';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';

export default [
  {
    label: '个人中心',
    href: '/agency/personal-center',
    hide: true,
    data: [
      {
        label: '个人中心',
        href: '/agency/personal-center',
        hide: true,
        data: [
          {
            label: '个人中心',
            href: '/agency/personal-center',
            component: loadable(() => import(/* webpackChunkName: 'personal' */ /* webpackMode: 'lazy' */ '@/pages/agency/personal-center/Layout'), { fallback: <Loading /> }),
            behavior: {
              editMobile: '修改手机号',
            },
            basePage: true,
          },
        ],
      },
    ],
  },
  {
    label: '微信登录',
    href: '/manage/wechatauth/index',
    key: 'wechatauth',
    component: loadable(() => import(/* webpackChunkName: 'manage' */ /* webpackMode: 'lazy' */ '@/pages/agency/manage/wechatauth/Layout'), { fallback: <Loading /> }),
    hide: true,
    purview: 119,
  },
];
